export default __webpack_public_path__ + "70c658cfa03fe9483b148c4c0f419378.png";